                                                               
import { AnalyticsEvent, trackAnalyticsEvent } from 'analytics';
          

export const trackNamAndCebAnalytics = (event: AnalyticsEvent) => {
	if (!IS_GATEWAY_PLUGIN_BUILD && !IS_STOREFRONT_PLUGIN_BUILD) {
		trackAnalyticsEvent(event);
	}
};
